import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { ModalModule } from 'ngx-bootstrap/modal'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { AppInitializerModule } from './app-initializer.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { NotAuthorizedInterceptor } from './authentication/not-authorized-interceptor'
import { AppCommonModule } from './common/common.module'
import { ConfiguracaoModule } from './configuracao/configuracao.module'
import { EstabelecimentosModule } from './estabelecimentos/estabelecimentos.module'
import { ExtratosModule } from './extratos/extratos.module'
import { FooterComponent } from './footer/footer.component'
import { AlertModule } from 'ngx-bootstrap/alert'

@NgModule({
    imports: [
        BrowserModule,
        AppInitializerModule,
        AppRoutingModule,
        AppCommonModule,
        ExtratosModule,
        ConfiguracaoModule,
        EstabelecimentosModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AlertModule.forRoot(),
        BsDropdownModule.forRoot(),
    ],
    declarations: [AppComponent, FooterComponent],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: NotAuthorizedInterceptor, multi: true },
    ],
    entryComponents: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts